import { Component } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router } from '@angular/router';
import { UserService } from 'app/shared/services/user.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'all-demand-component',
  templateUrl: './all-demand.component.html',
  styleUrls: ['./all-demand.component.scss'],
})
export class AllDemandComponent {
  constructor(public router: Router, public userService: UserService, public ga: GoogleAnalyticsService) {}

  ngOnDestroy() {}
}
